import { render } from "./OpenAccount.vue?vue&type=template&id=5168e88e&scoped=true"
import script from "./OpenAccount.vue?vue&type=script&lang=js"
export * from "./OpenAccount.vue?vue&type=script&lang=js"

import "./OpenAccount.vue?vue&type=style&index=0&id=5168e88e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5168e88e"]])

export default __exports__